import React from "react";
import { useI18n } from "@/i18n";
import { Languages } from "lucide-react";

export function LanguageToggle({ className = "", light = false }) {
  const { lang, setLang } = useI18n();
  return (
    <div
      className={`no-print flex items-center rounded-lg p-0.5 ${
        light ? "bg-white border border-slate-300" : "bg-slate-900/70 border border-slate-800"
      } ${className}`}
      data-testid="language-toggle"
    >
      <Languages size={13} className={`mx-1.5 shrink-0 ${light ? "text-slate-500" : "text-slate-500"}`} />
      {["tr", "en"].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          data-testid={`lang-${l}`}
          className={`px-2 py-1 rounded-md text-xs font-semibold uppercase transition-colors duration-200 ${
            lang === l
              ? "bg-indigo-600 text-white"
              : light
                ? "text-slate-500 hover:text-slate-900"
                : "text-slate-400 hover:text-slate-100"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
